<template>
    <div class="login-button-container">
        <button
            v-if="!loggedIn"
            class="login-button"
            @click="login()"
        >W-S Login</button>

        <button
            v-if="loggedIn"
            class="login-button"
            @click="logout()"
        >W-S Logout</button>
    </div>
</template>

<script setup lang="ts">
    import { useRequestStore } from '@/stores/requests'

    const requestStore = useRequestStore()
    const { loggedIn } = storeToRefs(requestStore)

    const { $login, $logout, $acquireTokenSilent, $checkAndGetToken } = useNuxtApp()

    const login = async() => {
        const loginResponse = await $login()

        if(loginResponse) {
            console.log(loginResponse)

            requestStore.setLoginState(true)
        }
    }

    const logout = async() => {
        await $logout()

        requestStore.setLoginState(false)
    }

    const checkLoginState = async () => {
        try {
            const response = await $checkAndGetToken()

            if (response) {
                requestStore.setLoginState(true)
            }
        } catch (error) {
            console.log(error)
            requestStore.setLoginState(false)
        }
    }

    onMounted(() => {
        checkLoginState()
    })
</script>